module.exports = __webpack_public_path__ + "static/daramola-56c0cc046d1359b41b022ff53189f259.png";